(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emiah-coupon-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('emiah-coupon-banner')) {
    customElements.define('emiah-coupon-banner', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-ecb-copy]');
          if (button && this.contains(button)) this.copyCode(button);
        }, { signal: this.controller.signal });
        const button = this.querySelector('[data-ecb-copy]');
        const code = this.querySelector('[data-ecb-code]')?.textContent.trim();
        if (button && code) button.hidden = false;
        if (button && !this.copying) {
          button.querySelector('[data-ecb-copy-label]').textContent = this.dataset.copyLabel;
          button.disabled = !code;
          this.querySelector('[data-ecb-status]').textContent = '';
          this.querySelector('[data-ecb-manual]').hidden = true;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.resetTimer);
      }

      legacyCopy(code) {
        const activeElement = document.activeElement;
        const input = document.createElement('textarea');
        input.value = code;
        input.readOnly = true;
        input.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;';
        this.append(input);
        try {
          input.focus({ preventScroll: true });
          input.select();
          input.setSelectionRange(0, code.length);
          return document.execCommand('copy');
        } catch {
          return false;
        } finally {
          input.remove();
          if (activeElement?.isConnected) activeElement.focus({ preventScroll: true });
        }
      }

      async copyCode(button) {
        if (this.copying || button.disabled) return;
        const code = this.querySelector('[data-ecb-code]')?.textContent.trim();
        if (!code) return;
        const label = button.querySelector('[data-ecb-copy-label]');
        const status = this.querySelector('[data-ecb-status]');
        const manual = this.querySelector('[data-ecb-manual]');
        this.copying = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        clearTimeout(this.resetTimer);
        let copied = false;
        try {
          if (window.isSecureContext && navigator.clipboard?.writeText) {
            try {
              await navigator.clipboard.writeText(code);
              copied = true;
            } catch {
              copied = this.legacyCopy(code);
            }
          } else {
            copied = this.legacyCopy(code);
          }
          if (!this.isConnected) return;
          if (copied) {
            label.textContent = this.dataset.copiedLabel;
            status.textContent = this.dataset.copiedLabel;
            manual.hidden = true;
            this.resetTimer = setTimeout(() => {
              label.textContent = this.dataset.copyLabel;
              status.textContent = '';
            }, 2000);
          } else {
            status.textContent = this.dataset.copyError;
            manual.hidden = false;
            const input = this.querySelector('[data-ecb-manual-input]');
            input.focus({ preventScroll: true });
            input.select();
            input.setSelectionRange(0, input.value.length);
          }
        } finally {
          this.copying = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emiah-media-voices"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('emiah-media-voices')) {
    customElements.define('emiah-media-voices', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.panels = Array.from(this.querySelectorAll('[data-emv-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-emv-tab]'));
        this.dots = Array.from(this.querySelectorAll('[data-emv-dot]'));
        if (!this.panels.length) return;
        this.viewport = this.querySelector('[data-emv-logos]');
        this.track = this.querySelector('[data-emv-track]');
        this.index = 0;
        this.motionIndex = 0;
        this.requestedIndex = 0;
        this.position = 0;
        this.middleStart = 0;
        this.items = [];
        this.copies = -1;
        this.animating = false;
        this.pending = null;
        this.motionTimer = null;
        this.layoutFrame = null;
        this.suppressClickUntil = 0;
        this.visible = false;
        this.hovering = false;
        this.focused = false;
        this.editorSelected = false;
        this.userPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.playButton = this.querySelector('[data-emv-play]');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => {
            if (performance.now() < this.suppressClickUntil) { event.preventDefault(); return; }
            this.select(index);
          }, options);
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            if (event.key === 'ArrowRight') this.moveBy(1);
            if (event.key === 'ArrowLeft') this.moveBy(-1);
            if (event.key === 'Home') this.select(0);
            if (event.key === 'End') this.select(this.panels.length - 1);
            this.tabs[this.requestedIndex].focus({ preventScroll: true });
          }, options);
          tab.querySelectorAll('img').forEach((image) => image.addEventListener('load', () => this.scheduleLayout(), options));
        });
        this.viewport.addEventListener('click', (event) => {
          const clone = event.target.closest('[data-emv-clone]');
          if (!clone || !this.track.contains(clone)) return;
          event.preventDefault();
          if (performance.now() < this.suppressClickUntil) return;
          this.select(Number(clone.dataset.emvIndex), 0, this.items.indexOf(clone));
          this.tabs[this.requestedIndex].focus({ preventScroll: true });
        }, options);
        this.track.addEventListener('transitionend', (event) => {
          if (event.target === this.track && event.propertyName === 'transform' && this.animating) this.finishMovement();
        }, options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), options));
        this.querySelector('[data-emv-prev]')?.addEventListener('click', () => this.moveBy(-1), options);
        this.querySelector('[data-emv-next]')?.addEventListener('click', () => this.moveBy(1), options);
        this.playButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updatePlayback();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovering = true; this.updatePlayback(); }, options);
        this.addEventListener('mouseleave', () => { this.hovering = false; this.updatePlayback(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.updatePlayback(); }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = !!event.relatedTarget && this.contains(event.relatedTarget);
          this.updatePlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.reducedMotion.addEventListener('change', () => { this.scheduleLayout(); this.updatePlayback(); }, options);
        [this.querySelector('[data-emv-quotes]'), this.viewport].forEach((area) => {
          area.addEventListener('pointerdown', (event) => {
            if (!event.isPrimary || event.pointerType === 'mouse' || event.target.closest('a')) return;
            this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
          }, options);
          area.addEventListener('pointerup', (event) => {
            const gesture = this.gesture;
            this.gesture = null;
            if (!gesture || gesture.id !== event.pointerId) return;
            const dx = event.clientX - gesture.x;
            const dy = event.clientY - gesture.y;
            if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              this.suppressClickUntil = performance.now() + 350;
              this.moveBy(dx < 0 ? 1 : -1);
            }
          }, options);
          area.addEventListener('pointercancel', () => { this.gesture = null; }, options);
        });
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail?.sectionId && String(event.detail.sectionId) !== this.dataset.sectionId) return;
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.select(index);
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          if (event.detail?.sectionId && String(event.detail.sectionId) !== this.dataset.sectionId) return;
          if (!this.panels.some((panel) => panel.dataset.blockId === event.detail?.blockId)) return;
          this.editorSelected = false;
          this.updatePlayback();
        }, options);
        document.addEventListener('shopify:section:unload', (event) => {
          if (String(event.detail?.sectionId) === this.dataset.sectionId) this.disconnectedCallback();
        }, options);
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.updatePlayback();
        }, { threshold: 0.1 });
        this.observer.observe(this);
        this.setAttribute('data-ready', '');
        this.layout();
        this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
        this.resizeObserver.observe(this.viewport);
        this.tabs.forEach((tab) => this.resizeObserver.observe(tab));
        window.addEventListener('resize', () => this.scheduleLayout(), options);
        const controller = this.controller;
        document.fonts?.ready.then(() => {
          if (this.controller === controller && this.isConnected) this.scheduleLayout();
        });
        document.fonts?.addEventListener('loadingdone', () => this.scheduleLayout(), options);
      }
      normalize(index) {
        return ((index % this.panels.length) + this.panels.length) % this.panels.length;
      }
      makeClone(tab, index) {
        const clone = document.createElement('span');
        clone.className = tab.className;
        clone.classList.remove('is-active');
        clone.dataset.emvClone = '';
        clone.dataset.emvIndex = index;
        clone.setAttribute('aria-hidden', 'true');
        [...tab.childNodes].forEach((child) => clone.appendChild(child.cloneNode(true)));
        clone.querySelectorAll('*').forEach((child) => {
          [...child.attributes].forEach((attribute) => {
            if (attribute.name === 'id' || attribute.name === 'tabindex' || attribute.name === 'role' || attribute.name.startsWith('aria-')) child.removeAttribute(attribute.name);
          });
        });
        return clone;
      }
      scheduleLayout() {
        if (!this.controller || this.layoutFrame !== null) return;
        this.layoutFrame = requestAnimationFrame(() => {
          this.layoutFrame = null;
          if (this.controller && this.isConnected) this.layout();
        });
      }
      layout() {
        if (!this.controller || !this.viewport.clientWidth) return;
        window.clearTimeout(this.motionTimer);
        this.motionTimer = null;
        this.animating = false;
        this.pending = null;
        this.removeAttribute('data-animating');
        this.viewport.scrollLeft = 0;
        const first = this.tabs[0];
        const last = this.tabs[this.tabs.length - 1];
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        if (this.classList.contains('emiah-media-voices--spotlight')) {
          const visibleCount = window.innerWidth < 750 ? 3 : window.innerWidth >= 1280 ? 5 : 4;
          this.style.setProperty('--emv-logo-slot', `${Math.max(44, (this.viewport.clientWidth - gap * (visibleCount - 1)) / visibleCount)}px`);
        }
        const cycleWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft + gap;
        const copies = this.tabs.length > 1 ? Math.max(2, Math.ceil(this.viewport.clientWidth / Math.max(1, cycleWidth)) + 1) : 0;
        if (copies !== this.copies) {
          this.track.querySelectorAll('[data-emv-clone]').forEach((clone) => clone.remove());
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          for (let copy = 0; copy < copies; copy += 1) {
            this.tabs.forEach((tab, index) => { before.appendChild(this.makeClone(tab, index)); after.appendChild(this.makeClone(tab, index)); });
          }
          this.track.prepend(before);
          this.track.append(after);
          this.copies = copies;
        }
        this.items = [...this.track.children];
        this.items.forEach((item, position) => { item.dataset.emvPosition = position; });
        this.middleStart = copies * this.tabs.length;
        this.index = this.normalize(this.requestedIndex);
        this.motionIndex = this.index;
        this.position = this.middleStart + this.index;
        this.updateSelection();
        this.rebase(this.position);
        this.updatePlayback();
      }
      moveBy(direction) {
        this.select(this.requestedIndex + direction, Math.sign(direction));
      }
      select(index, direction = 0, physicalPosition = null) {
        if (!this.controller || !Number.isFinite(index)) return;
        const target = this.normalize(index);
        this.requestedIndex = target;
        if (!this.items.length) {
          this.index = target;
          this.updateSelection();
          this.scheduleLayout();
          return;
        }
        if (this.animating) {
          this.index = target;
          this.updateSelection();
          this.pending = { index: target, direction };
          this.updatePlayback();
          return;
        }
        this.performSelection(target, direction, physicalPosition);
      }
      performSelection(target, direction = 0, physicalPosition = null) {
        const count = this.tabs.length;
        let distance = target - this.motionIndex;
        if (direction > 0) distance = (target - this.motionIndex + count) % count;
        else if (direction < 0) distance = -((this.motionIndex - target + count) % count);
        else {
          if (distance > count / 2) distance -= count;
          if (distance < -count / 2) distance += count;
        }
        const nextPosition = physicalPosition ?? this.position + distance;
        const animate = nextPosition !== this.position && !this.reducedMotion.matches;
        this.index = target;
        this.motionIndex = target;
        this.position = nextPosition;
        this.updateSelection();
        this.markVisual(nextPosition);
        this.animating = animate;
        this.centerPosition(nextPosition, animate);
        if (animate) {
          this.setAttribute('data-animating', '');
          this.motionTimer = window.setTimeout(() => this.finishMovement(), 360);
        } else this.finishMovement();
        this.updatePlayback();
      }
      centerPosition(position, animate) {
        const item = this.items[position];
        if (!item) return;
        this.track.style.transition = animate ? '' : 'none';
        const itemRect = item.getBoundingClientRect();
        const trackRect = this.track.getBoundingClientRect();
        const offset = this.viewport.getBoundingClientRect().width / 2 - (itemRect.left - trackRect.left) - itemRect.width / 2;
        this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
      }
      markVisual(position) {
        this.items.forEach((item, itemPosition) => item.classList.toggle('is-active', position === itemPosition));
      }
      rebase(position) {
        this.setAttribute('data-rebasing', '');
        this.markVisual(position);
        this.centerPosition(position, false);
        this.track.getBoundingClientRect();
        this.removeAttribute('data-rebasing');
      }
      finishMovement() {
        if (!this.controller) return;
        window.clearTimeout(this.motionTimer);
        this.motionTimer = null;
        this.animating = false;
        this.removeAttribute('data-animating');
        this.position = this.middleStart + this.motionIndex;
        this.rebase(this.position);
        const pending = this.pending;
        this.pending = null;
        if (pending && pending.index !== this.motionIndex) this.performSelection(pending.index, pending.direction);
        else this.updatePlayback();
      }
      updateSelection() {
        this.panels.forEach((panel, item) => {
          const active = item === this.index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[item].id);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
          panel.tabIndex = active ? 0 : -1;
        });
        this.tabs.forEach((tab, item) => {
          const active = item === this.index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.dots.forEach((dot, item) => {
          dot.classList.toggle('is-active', item === this.index);
          dot.setAttribute('aria-pressed', String(item === this.index));
        });
      }
      updatePlayback() {
        window.clearTimeout(this.timer);
        this.timer = null;
        if (!this.controller) return;
        const paused = this.userPaused || this.reducedMotion.matches;
        if (this.playButton) {
          this.playButton.textContent = paused ? '▶' : 'Ⅱ';
          this.playButton.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        }
        if (this.dataset.autoplay !== 'true' || this.panels.length < 2 || paused || this.animating || !this.visible || this.hovering || this.focused || this.editorSelected || document.hidden) return;
        this.timer = window.setTimeout(() => this.moveBy(1), Math.max(3000, Number(this.dataset.interval) || 5000));
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.motionTimer);
        cancelAnimationFrame(this.layoutFrame);
        this.timer = null;
        this.motionTimer = null;
        this.layoutFrame = null;
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.track?.querySelectorAll('[data-emv-clone]').forEach((clone) => clone.remove());
        this.track?.style.removeProperty('transform');
        this.track?.style.removeProperty('transition');
        this.style.removeProperty('--emv-logo-slot');
        this.tabs?.forEach((tab, index) => tab.classList.toggle('is-active', index === this.index));
        if (this.viewport) this.viewport.scrollLeft = 0;
        this.removeAttribute('data-ready');
        this.removeAttribute('data-animating');
        this.removeAttribute('data-rebasing');
        this.controller = null;
        this.observer = null;
        this.resizeObserver = null;
        this.pending = null;
        this.animating = false;
        this.gesture = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
